import {NgStyle} from '@angular/common';
import {TranslatePipe} from '@ngx-translate/core';
import {Slide} from '@app/common/interfaces/slide';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
  imports: [
    TranslatePipe,
    NgStyle
  ]
})
export class SliderComponent implements OnInit, OnDestroy {

  @Input() slides: Slide[] = [];
  @Input() withBackground = true;

  public activeIndex = 0;
  private autoPlayDuration = 20000;
  private interval: any;

  constructor() {
  }

  ngOnInit() {
    this.setIndex(0);
    this.setAutoPlay();
  }

  ngOnDestroy() {
    this.clearInterval();
  }

  private setAutoPlay(): void {
    this.interval = setInterval(() => {
      const number: number = ++this.activeIndex;
      this.setIndex(number);
    }, this.autoPlayDuration);
  }

  private setIndex(index: number) {
    if (index === this.slides.length) {
      this.activeIndex = 0;
      return;
    }
    if (index < 0) {
      this.activeIndex = this.slides.length - 1;
      return;
    }
    this.activeIndex = index;
  }

  private clearInterval(): void {
    clearInterval(this.interval);
  }

  private resetTimer(): void {
    this.clearInterval();
    this.setAutoPlay();
  }

  public action(action: string): void {
    this.resetTimer();
    this.setIndex(action === 'next' ? ++this.activeIndex : --this.activeIndex);
  }

}
